import { PROTOCOL } from "@/base/base.constants";

const ALEXANDRIA_HOST =
  process?.env?.["NEXT_PUBLIC_ALEXANDRIA_HOST"] || "alexandria.newsela.com";

export const ALEXANDRIA_URL = `${PROTOCOL}://${ALEXANDRIA_HOST}`;

export const TAXONOMY_DRAWER_ZINDEX = 1000;
